import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../../util/helpers';

export default {
  init: function () {

    var creditCardForm = $('#creditCardForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = creditCardForm.valid();
        if (valid) {
          setTimeout(function () {
            creditCardForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

    creditCardForm.validate({
      errorElement: "span",
      rules: {
        cardnumber: {
          creditcard: true,
          required: true,
        },
      },
      errorPlacement: function (error, element) {

        if (element.attr("name") == "exp_month" || element.attr("name") == "exp_year") {


          if($( "span.custom" ).length) {
            $( "span.custom" ).remove();
          }

          $(".input-like-select").addClass("error");
          error.addClass("custom");
          error.insertAfter($(".input-like-select"));

        } else {

          error.insertAfter(element);

        }
      },
      showErrors: function (errors) {
        if (errors) {

          this.defaultShowErrors();

        }

        if ($("#inputCardExpMonth").hasClass("valid") && $("#inputCardExpYear").hasClass("valid")) {
          $(".input-like-select").removeClass("error");
        }

      },
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/creditcard.js